<div class="container-fluid main-container">
    <div class="row">
        <div class="col-sm-12">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>